import { useQuery } from "@tanstack/react-query";

import { getV3Api } from "../apiConfiguration";

const api = getV3Api();

// Returns current contract of the selected organisation
export function useOrganisationContract(uniqueId: string) {
  const contractsListResponse = useQuery({
    queryKey: ["contractslist", uniqueId],
    queryFn: () => api.contractsList({ organisationUniqueId: uniqueId }),
    enabled: !!uniqueId,
  });

  if (contractsListResponse.isSuccess) {
    return contractsListResponse.data.results.length > 0
      ? contractsListResponse.data.results[0]
      : null;
  } else {
    return null;
  }
}
